<template>
  <b-row align-h="center">
    <b-col sm="12" md="6" lg="4">
      <h2>Digital Display Login</h2>
      <b-form @submit="onSubmit">
        <b-form-group label="Email address:">
          <b-form-input v-model="form.email"  type="email" required placeholder="Email"/>
        </b-form-group>

        <b-form-group label="Password">
          <b-form-input v-model="form.password" type="password" required placeholder="Password"/>
        </b-form-group>


        <b-row align-v="center">
          <b-col>
            <b-button type="submit" variant="primary" :disabled="formLoading">Login</b-button>
          </b-col>
          <b-col>
            <b-link :to="{name: 'forgot'}" :disabled="formLoading">Forgot password</b-link>
          </b-col>
          <b-spinner v-show="formLoading" small label="Small Spinner"></b-spinner>
        </b-row>
        <b-row>
            <b-col>
              <b-link :to="{name: 'privacy'}" :disabled="formLoading"  class="fixed-bottom m-2">Privacy policy</b-link>
            </b-col>
          </b-row>
      </b-form>
    </b-col>
  </b-row>
</template>

<script>
import formsMixin from '@/mixins/forms';

export default {
  mixins: [formsMixin],
  props: {
    message: {
      type: [String],
      required: false,
    },
  },
  watch: {
    message: {
      immediate: true,
      deep: true,
      handler(newMessage) {
        if (newMessage) {
          this.$root.$emit('notification-add', { content: newMessage, variant: 'info' });
        }
      },
    },
  },
  data() {
    return {
      storeDispatchTarget: 'AuthStore/loginWithCredentials',
      routerTarget: { name: 'admin' },
      form: {
        email: '',
        password: '',
      },
      formErrors: {
        email: null,
        password: null,
      },
    };
  },
};
</script>
